import React, { useMemo } from "react";
import SellerCard from "./SellerCard";
import { Seller } from "../types";
import { usePersistStore } from "../store";
import { useTopSellers } from "../hooks/queries";

const TopSellers: React.FC = () => {
  const { currentLocation } = usePersistStore((s: any) => s);
  const { data = [] } = useTopSellers(currentLocation);

  const list: Seller[] = useMemo(
    () =>
      (data || []).map((seller: any) => ({
        name: seller?.name,
        imageUrl: seller?.fileUrl,
        sold: seller?.salesCount ?? 0,
        distance: seller?.distance,
        profileUrl: `/seller/${seller?._id}`,
        city: seller?.city,
        state: seller?.state,
        speciality: seller?.speciality,
        badges: seller?.badges || [],
      })),
    [data]
  );

  return (
    <>
      {list.map((seller: Seller, index) => (
        <SellerCard seller={seller} key={index} />
      ))}
    </>
  );
};

export default TopSellers;
